const siteBaseUrl = process.env.VUE_APP_BASE_URL || '';

function articleLink(relativePath) {
  return siteBaseUrl + relativePath;
}

export {
  articleLink
}